import { FaCalendarCheck, FaUserCheck, FaClock, FaMapMarkerAlt } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaCalendarCheck />, // 活動舉辦的日曆圖示
        title: '競賽項目',
        count: '18',
    },
    {
        id: 2,
        icon: <FaUserCheck />, // 參與者的使用者確認圖示
        title: '參賽人數',
        count: '600',
    },
    {
        id: 3,
        icon: <FaClock />, // 營運年數的時鐘圖示
        title: '營運年數',
        count: '10',
    },
    {
        id: 4,
        icon: <FaMapMarkerAlt />, // 舉辦地點的地圖標記圖示
        title: '舉辦國家',
        count: '6',
    },
];

export default counter;
